module.exports = __webpack_public_path__ + "static/gallery_15-thumb-7e285d8ed87adc85122daf239ecba516.jpg";